// src/components/WineClub/Success.tsx

import React from 'react';
import { Link } from 'react-router-dom';

const Success: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[75vh] bg-gold text-cream font-satoshi">
      <h1 className="text-4xl font-recia mb-4">Thank You!</h1>
      <p className="mb-8">Your subscription to the Wine Club was successful.</p>
      <Link to="/" className="bg-maroon text-cream font-satoshi px-6 py-2 rounded-full">
        Return to Home
      </Link>
    </div>
  );
};

export default Success;